import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import withTranslations from '../../utils/HighOrderComponent';
import { confirmDialog } from '../Reusable/ConfirmDialog';
import ModalForDecisionTypeUpdateAndPreview from './ModalForDecisionTypeUpdateAndPreview';

class DecisionTypeRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showUpdate: false,
      showPreview: false,
    };
  }

  onDeleteClick = (id) => {
    const translation = this.props.t.ConfirmDialog;
    const action = () => {
      this.props.deleteDecisionType(id, this.props.messageTitle);
    };
    confirmDialog(
      translation.confirmMessage,
      action,
      translation.confirmDelete,
      this.props.gt
    );
  };

  showModalUpdate = () => {
    this.setState({ showUpdate: true });
  };

  showModalPreview = () => {
    this.setState({ showPreview: true });
  };

  handlePreviewClose = () => {
    this.setState({
      showUpdate: false,
      showPreview: false,
    });
    this.props.deleteError();
    this.props.deleteErrorDecisionTypeAttachment();
  };

  handleEdit = (decisionType, type) => {
    this.props.updateDecisionType(
      decisionType,
      this.handlePreviewClose,
      type,
      this.props.messageTitle
    );
  };

  handleUpdateDecisionTypeWithAttachment = (formData, type) => {
    this.props.updateDecisionTypeWithAttachment(
      formData,
      this.handlePreviewClose,
      type,
      this.props.messageTitle
    );
  };

  render() {
    const {
        decisionType,
        deleteError,
        findDecisionTypeAttachment,
        findDecisionTypeAttachmentByDecisionTypeName,
        decisionContent,
        format,
        error,
      } = this.props || {},
      { name, description } = decisionType || {};

    const decisionTypeRow = (
      <tr className="text-center">
        <td className="text-left">{this.props.index}</td>
        <td>{name}</td>
        <td>{description}</td>
        <td className="text-center">
          <Link
            onClick={(e) => {
              this.showModalPreview();
            }}
            to="#"
          >
            <i className="fas fa-search fa-2x" />
          </Link>
        </td>
        <td>
          <Link
            onClick={(e) => {
              this.showModalUpdate();
            }}
            to="#"
          >
            <i className="fas fa-edit fa-2x" />
          </Link>
        </td>
        <td>
          <Link
            id="deleteUser"
            onClick={() => this.onDeleteClick(this.props.decisionType.id)}
            to="#"
          >
            <i className="fas fa-trash-alt fa-2x" />
          </Link>
        </td>
      </tr>
    );

    return (
      <Fragment>
        {decisionTypeRow}
        {this.state.showUpdate && (
          <ModalForDecisionTypeUpdateAndPreview
            show={this.state.showUpdate}
            decisionType={decisionType}
            updateDecisionType={this.handleEdit}
            handleClose={this.handlePreviewClose}
            error={error}
            deleteError={deleteError}
            findDecisionTypeAttachment={findDecisionTypeAttachment}
            findDecisionTypeAttachmentByDecisionTypeName={
              findDecisionTypeAttachmentByDecisionTypeName
            }
            decisionContent={decisionContent}
            format={format}
            handleUpdateDecisionTypeWithAttachment={
              this.handleUpdateDecisionTypeWithAttachment
            }
            isPreview={false}
          />
        )}

        {this.state.showPreview && (
          <ModalForDecisionTypeUpdateAndPreview
            show={this.state.showPreview}
            decisionType={decisionType}
            updateDecisionType={this.handleEdit}
            handleClose={this.handlePreviewClose}
            error={error}
            deleteError={deleteError}
            findDecisionTypeAttachment={findDecisionTypeAttachment}
            findDecisionTypeAttachmentByDecisionTypeName={
              findDecisionTypeAttachmentByDecisionTypeName
            }
            decisionContent={decisionContent}
            format={format}
            handleUpdateDecisionTypeWithAttachment={
              this.handleUpdateDecisionTypeWithAttachment
            }
            isPreview={true}
          />
        )}
      </Fragment>
    );
  }
}

export default withTranslations(DecisionTypeRow, 'DecisionTypeRow');
